<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ZBREAK"></p>
<p class="AUTHOR"><span>N</span>.<span>T</span><span>.</span>Wright</p>
<p class="TITLE" id="toc_marker-1">The Lord<br/>and His<br/>Prayer</p>
<p class="COMPANY">William B. Eerdmans Publishing Company<br/>Grand Rapids, Michigan / Cambridge, U.K.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Wright_The_Lord_and_His_Prayer_text.vue?60290929